import { CallType } from 'features/call/call-base/enums';
import { VrsCallType } from 'features/call/vrs-call/enums';

export const shouldShowLeaveQueueButton = (
  callType: CallType | null = CallType.REGULAR_CALL,
  vrsCallType: VrsCallType | null = VrsCallType.REGULAR_CALL
): boolean => {
  // Handle null values by using defaults
  const actualCallType = callType || CallType.REGULAR_CALL;
  const actualVrsCallType = vrsCallType || VrsCallType.REGULAR_CALL;

  const isEmergencyCallType = actualCallType === CallType.EMERGENCY_CALL;
  const isEmergencyVrsType =
    actualVrsCallType === VrsCallType.EMERGENCY_CALL ||
    actualVrsCallType === VrsCallType.EMERGENCY_CALLBACK;
  if (isEmergencyCallType || isEmergencyVrsType) {
    return false;
  }

  const isColdHandoff = actualCallType === CallType.COLD_HANDOFF_CALL;
  if (isColdHandoff) {
    return true;
  }

  const isRegularOrFastVrsType =
    actualVrsCallType === VrsCallType.REGULAR_CALL ||
    actualVrsCallType === VrsCallType.FAST_CALL;
  const isTeamingRegularCall = actualCallType === CallType.TEAMING_REGULAR_CALL;
  const isConferenceOrTeamingConference =
    actualCallType === CallType.CONFERENCE_CALL ||
    actualCallType === CallType.TEAMING_CONFERENCE_CALL;

  return (
    isRegularOrFastVrsType ||
    isTeamingRegularCall ||
    isConferenceOrTeamingConference
  );
};
